// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1E1NZ","calendarButtons":"ClockData_calendarButtons__2fLmF"};